import { Theme } from '@mui/material';
import { CSSProperties } from '@mui/material/styles/createMixins';
/**
 * Creates css rules for making a component scrollable in y-direction.
 * Should only be used where the component should take all of the apps's main container's height.
 *
 * @param theme
 */
export const scrollableY = (theme: Theme): CSSProperties => ({
    height: `calc(100vh - ${theme.mixins.toolbar.minHeight}px - ${theme.spacing(4)}px)`,
    overflowY: 'auto',
    overflowX: 'hidden',
    ...scrollbar(theme)
});

/**
 * Scrollbar styling
 * @param theme
 */
export const scrollbar = (theme: Theme): CSSProperties => ({
    '&::-webkit-scrollbar': {
        '-webkit-appearance': 'none'
    },

    '&::-webkit-scrollbar:vertical': {
        width: 11
    },

    '&::-webkit-scrollbar:horizontal': {
        height: 11
    },

    '&::-webkit-scrollbar-thumb': {
        borderRadius: 8,
        border: '2px solid #f5f5f5',
        backgroundColor: theme.palette.primary.main
    },

    '&::-webkit-scrollbar-track': {
        borderRadius: 8
    }
});
